module.exports = __webpack_public_path__ + "img/组 3@2x.6c1ce706.png";